(function () {
    function initHomeCategoriesSlider(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-categories-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
        var paginationElement = sectionElement.querySelector('[data-home-categories-pagination]');
        var transitionSpeed = Number(sectionElement.dataset.homeCategoriesSpeed) || 900;
        var mobileSlides = Number(sectionElement.dataset.homeCategoriesMobileSlides) || 1;
        var mobileSpaceBetween = 16;

        sectionElement.dataset.initialized = 'true';

        if (slideCount <= 1) {
            if (paginationElement) {
                paginationElement.hidden = true;
            }

            return;
        }

        var swiper = new window.Swiper(sliderElement, {
            slidesPerView: mobileSlides,
            spaceBetween: mobileSpaceBetween,
            speed: transitionSpeed,
            loop: false,
            watchOverflow: true,
            centerInsufficientSlides: true,
            breakpoints: {
                750: {
                    enabled: false
                }
            },
            pagination: paginationElement ? {
                el: paginationElement,
                clickable: true
            } : undefined
        });
    }

    window.filadelfiaHomeCategoriesSlider = {
        init: initHomeCategoriesSlider
    };
})();
